import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedNumber } from "react-intl";

import messages from "./messages";

class PointsLabel extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function

  render() {
    const { points, style } = this.props;
    return (
      <span className='pointsEarned' style={style}>
        <FormattedNumber value={points} />
        &nbsp;
        <FormattedMessage {...messages.points} />
      </span>
    );
  }
}

PointsLabel.propTypes = {
  points: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default PointsLabel;
